'use client';
import type { UntypedFunction } from '@mnd-frontend/ts';
import { RED_700 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import { useEventContext, useHoveredContext, useSelectedContext } from '../lib/context';

const BubbleCircle = styled.circle<{
  $hovered: boolean;
  $color: string;
}>`
  cursor: pointer;
  fill: ${props => (props.$hovered ? RED_700 : props.$color)};
  transition: r 0.2s;
`;

const Bubble = ({
  id,
  x,
  y,
  r,
  color,
  isHoveredDay,
}: {
  id: string;
  x?: number | string;
  y?: number | string;
  r: number;
  color: string;
  isHoveredDay: UntypedFunction;
}) => {
  const { handleMouseEnter, handleMouseLeave, handleClick } = useEventContext();
  const isHovered = useHoveredContext();
  const isSelected = useSelectedContext();

  const highlight = isHovered(id) || isSelected(id) || isHoveredDay(id);

  return (
    <BubbleCircle
      $hovered={highlight}
      cx={x}
      cy={y}
      r={r + (highlight ? 3 : 1)}
      $color={color}
      onClick={event => handleClick(id, event)}
      onMouseEnter={event => handleMouseEnter(id, event)}
      onMouseLeave={event => handleMouseLeave(id, event)}
    />
  );
};

export default Bubble;
